import styled from "@emotion/styled/macro";
import { useCapContext } from "../../providers/CapContext";
import { ClassicViewPillTooltip } from "components/molecules/ClassicViewPillTooltip";
import { useOfferReviewSimplifiedIneligibleReason } from "hooks/useOfferReviewSimplifiedIneligibleReason";

type CapClassicViewIndicatorProps = {
  isMobile: boolean;
  isTablet: boolean;
};

const CapClassicViewIndicator = ({
  isMobile,
  isTablet,
}: CapClassicViewIndicatorProps) => {
  const {
    isCustomer,
    isCapSimplifiedExperience,
    capSimplifiedIneligibleReason,
    isCapSimplifiedGatePending,
  } = useCapContext();
  const { reason, breezeCreatedDateCutoff } =
    useOfferReviewSimplifiedIneligibleReason({
      presentationSource: "cap",
      isCustomer,
      isCapSimplifiedExperience,
      capSimplifiedIneligibleReason,
      isCapSimplifiedGatePending,
    });

  if (reason === null) {
    return null;
  }

  return (
    <PillAnchor isMobile={isMobile} isTablet={isTablet}>
      <ClassicViewPillTooltip
        reason={reason}
        breezeCreatedDateCutoff={breezeCreatedDateCutoff}
        tooltipTestId="cap-breeze-ineligible-tooltip"
      />
    </PillAnchor>
  );
};

const PillAnchor = styled.div<{ isMobile: boolean; isTablet: boolean }>`
  position: absolute;
  top: ${({ isMobile, isTablet }) =>
    isMobile ? "16px" : isTablet ? "24px" : "40px"};
  right: ${({ isMobile, isTablet }) =>
    isMobile ? "16px" : isTablet ? "24px" : "64px"};
  z-index: 2;
`;

export { CapClassicViewIndicator };
